import React, { useState, useEffect } from "react";
import { Select, Row, Col, Form, message } from "antd";
import { fetchBrandsBySelectedClients } from "../../../core/api/settings";
import { useSelector } from "react-redux";
import { getAllCosts } from "../../../core/api/mediaplan";
import CostsTable from "./CostsTable";
import FixedCostsForm from "./FixedCostsForm";
import VariableCostsForm from "./VariableCostsForm";

const { Option } = Select;

const CostsTab = () => {
  const [brandOptions, setBrandOptions] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [costs, setCosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const selectedClients = useSelector((state) => state.selectedClients);

  useEffect(() => {
    if (selectedClients && selectedClients.length > 0) {
      fetchBrands();
      fetchCosts();
    }
  }, [selectedClients]);

  const fetchBrands = async () => {
    try {
      const response = await fetchBrandsBySelectedClients(selectedClients);
      const brands = response.data.map((brand) => ({
        label: brand.brand_name || brand.name,
        value: brand.id,
      }));

      setBrandOptions(brands);

      if (brands.length === 1) {
        setSelectedBrand(brands[0].value);
        form.setFieldsValue({ brand: brands[0].value });
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
      message.error("Failed to fetch brands");
    }
  };

  const fetchCosts = async () => {
    setLoading(true);
    try {
      const response = await getAllCosts();
      setCosts(response.data);
    } catch (error) {
      console.error("Error fetching costs:", error);
      message.error("Failed to fetch costs");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="costs-tab">
      <Row gutter={16}>
        <Col span={24}>
          <Form form={form} layout="vertical" size="small">
            <Form.Item
              label="Select Brand"
              name="brand"
              rules={[{ required: true, message: "Please select a brand" }]}
            >
              <Select
                placeholder="Select brand"
                options={brandOptions}
                onChange={(value) => setSelectedBrand(value)}
                style={{ width: "40%" }}
              />
            </Form.Item>

            <FixedCostsForm
              selectedBrand={selectedBrand}
              form={form}
              onCostAdded={fetchCosts}
            />
            <Col span={24}>
              <CostsTable costs={costs} loading={loading} />
            </Col>
          </Form>
        </Col>
        <VariableCostsForm selectedBrand={selectedBrand} />
      </Row>
    </div>
  );
};

export default CostsTab;
